import React from "react";
import Styles from "../../styles/sorting/SortingAlgo.module.css";

let highlight: number = 0;

const SortingAlgo = (props: any) => {
  return (
    <div
      className={Styles.algoContainer}
      onClick={() => {
        props.setAlgoName(props.algName);
        highlight = props.number;
      }}
      style={{
        backgroundColor: props.number === highlight ? "#000" : "#22222d",
        borderWidth: 0,
        borderBottomWidth: props.number === highlight ? 2 : 0,
        borderBottomColor: "#880088",
        borderStyle: "solid",
      }}
    >
      <p className={Styles.algoName}>{props.algName}</p>
    </div>
  );
};

const SortingAlgoComponent = (props: any) => {
  const algos: string[] = [
    "BUBBLE SORT",
    "SELECTION SORT",
    "INSERTION SORT",
    "SHELL SORT",
    "QUICK SORT",
    "MERGE SORT",
    // "HEAP SORT",
    // "REDIX SORT",
    // "COUNTING SORT",
    // "BUCKET SORT",
  ];

  return (
    <div className={Styles.container}>
      {algos.map((algName: string, index: number) => (
        <SortingAlgo
          key={index}
          number={index}
          algName={algName}
          setAlgoName={props.setAlgoName}
        />
      ))}
    </div>
  );
};

export default SortingAlgoComponent;
